import React, { useContext, useState } from "react";
import { Container, Header, Tab, TabContainer, TherapistsTitle } from "./styled";
import { ButtonContainer, Icon } from "ui/styled";
import Button from "components/Form/Button";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { CoreContext } from "context/CoreContext";
import HorizontalScrollCarousel from "components/HorizontalScrollCarousel";



export default function OfficeTabs({ options, title }) {
  const history = useHistory();
  const navigate = to => history.push(`/${to}`);
  const { setModal } = useContext(CoreContext)
  const location = useLocation()
  const secondOption = location.pathname.split('/')[1];


  return (
    <Container>
      <Header>
        {/* <TherapistsTitle>{title}</TherapistsTitle> */}
      </Header>
      <TabContainer>
        <HorizontalScrollCarousel>
          {options?.map((tab) => (
            <Tab key={tab} active={tab?.page.split('/').includes(secondOption)} onClick={() => navigate(tab?.page)
            }>
              {tab?.title}
            </Tab>
          ))}
        </HorizontalScrollCarousel>
      </TabContainer>
    </Container>
  );
}